"use client";

import { PricingPageContent } from "../../../patterns/PricingPageContent";

export function PricingPage() {
  return <PricingPageContent />;
}

PricingPage.displayName = "PricingPage";
